import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditAffiliateForm = ({ editPopup, setEditPopup }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [address, setAddress] = useState("");
  const [proffesion, setProffesion] = useState("");
  const [gst, setGst] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isGstValid, setIsGstValid] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [date, setDate] = useState("");

  const formatDateForInput = (inputDate) => {
    if (!inputDate) return '';
    const dateObj = new Date(inputDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$1-$2'));
    if (isNaN(dateObj.getTime())) return ''; // Check for invalid date
    const year = dateObj.getFullYear();
    const month = `${dateObj.getMonth() + 1}`.padStart(2, "0");
    const day = `${dateObj.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDateForPayload = (date) => {
    if (!date) return '';
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    if (editPopup) {
      setName(editPopup.name || "");
      setEmail(editPopup.email || "");
      setPhone(editPopup.phone || "");
      setAddress(editPopup.address || "");
      setNewPassword("");
      setGst(editPopup.gst || "");
      setProffesion(editPopup.proffesion || "");
      setCreatedby(editPopup.createdby || "");

      // FIX 1: Explicitly use `editPopup.companyname`. If it is null or undefined, it will show an empty string.
      // This correctly handles the case where the database field is empty.
      setCompanyname(editPopup.companyname || "");

      // FIX 2: Explicitly use `editPopup.dob` for Date of Birth.
      // If `editPopup.dob` is empty in the database, the input will be empty.
      // If you are seeing the creation date, it means the API is sending the wrong data in the 'dob' field.
      setDate(formatDateForInput(editPopup.dob));
    }
  }, [editPopup]);


  const handleClose = () => {
    setEditPopup(false);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const validateGst = (gst) => {
    if (!gst || gst.trim() === "") return true;
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}\d{1}$/;
    return gstRegex.test(gst) && gst.length === 15;
  };

  // If you want the password to be optional on update, change this logic
  const validatePassword = (password) => {
    // For now, it remains required as per your existing code
    return password.trim() !== "";
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    const isGstValid = validateGst(gst);
    const isPasswordValid = validatePassword(newPassword);
    
    setIsEmailValid(isEmailValid);
    setIsPhoneValid(isPhoneValid);
    setIsGstValid(isGstValid);
    setIsPasswordValid(isPasswordValid);

    if (isEmailValid && isPhoneValid && isGstValid && isPasswordValid) {
      try {
        const affiliateData = {
          id: editPopup._id,
          email,
          name,
          phone,
          password: newPassword,
          dob: formatDateForPayload(date),
          address,
          proffesion,
          gst,
          companyname,
        };

        const response = await axios.put(
          `${Constant.BASE_URL}/affiliate/update`,
          affiliateData
        );

        if (response.status === 200) {
          toast.success("Affiliate Updated Successfully");
          setTimeout(() => {
            setEditPopup(false);
          }, 2000);
        } else {
          console.log("Update failed:", response.status);
          toast.error("Failed to update affiliate.");
        }
      } catch (error) {
        console.log(error);
        toast.error("An error occurred during update.");
      }
    } else {
        if (!isPasswordValid) {
            toast.error("Password is required.");
        }
    }
  };
  
  if (!editPopup) return null;

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="popup-form fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-md shadow-md py-3 px-1 w-fit max-h-[90vh] overflow-y-auto">
              <div className="lg:w-[600px] xl:w-[630px] 2xl:w-[800px]">
                  <div className="text-lg font-semibold text-center mb-4 2xl:text-2xl 2xl:py-3">
                      Edit Affiliate
                  </div>
                  <hr className="mt-1" />
                  <form onSubmit={handleUpdate}>
                      <div className="flex flex-col md:flex-row items-start justify-center lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[16px]">
                          <div className="w-full md:w-1/2 md:pr-3 md:border-r">
                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-name" className="flex items-center px-3 w-1/3">
                                      Name :<span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <input
                                      type="text"
                                      id="edit-name"
                                      className="border-b border-gray-500 outline-none w-2/3 p-1"
                                      placeholder="Name"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                      required
                                  />
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-phone" className="flex items-center px-3 w-1/3">
                                      Phone :<span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="flex flex-col w-2/3">
                                      <input
                                          type="tel"
                                          id="edit-phone"
                                          className="border-b border-gray-500 outline-none p-1"
                                          value={phone}
                                          onChange={(e) => setPhone(e.target.value)}
                                          placeholder="10-digit number"
                                          required
                                      />
                                      {!isPhoneValid && (
                                          <p className="text-red-500 text-xs mt-1">Invalid phone format (10 digits)</p>
                                      )}
                                  </div>
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-email" className="flex items-center px-3 w-1/3">
                                      Email :<span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="flex flex-col w-2/3">
                                      <input
                                          type="text"
                                          id="edit-email"
                                          className="border-b border-gray-500 outline-none p-1"
                                          value={email}
                                          onChange={(e) => setEmail(e.target.value)}
                                          placeholder="Email"
                                          required
                                      />
                                      {!isEmailValid && (
                                          <p className="text-red-500 text-xs mt-1">Invalid email format</p>
                                      )}
                                  </div>
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-password" className="flex items-center px-3 w-1/3">
                                      Password :<span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="flex flex-col w-2/3">
                                    <div className="relative w-full">
                                        <input
                                            type={togglePassword ? "text" : "password"}
                                            id="edit-password"
                                            className="border-b border-gray-500 outline-none w-full p-1"
                                            placeholder="New Password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                        <span onClick={() => setTogglePassword(!togglePassword)} className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer">
                                            {togglePassword ? <IoEye /> : <RiEyeCloseLine />}
                                        </span>
                                    </div>
                                    {!isPasswordValid && <p className="text-red-500 text-xs mt-1">Password is required</p>}
                                  </div>
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-companyname" className="flex items-center px-3 w-1/3">
                                      Company Name :
                                  </label>
                                  <input
                                      type="text"
                                      id="edit-companyname"
                                      className="border-b border-gray-500 outline-none w-2/3 p-1"
                                      placeholder="Company name"
                                      value={companyname}
                                      onChange={(e) => setCompanyname(e.target.value)}
                                  />
                              </div>
                          </div>

                          <div className="w-full md:w-1/2 md:pl-3">
                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-date" className="flex items-center px-3 w-1/3">
                                      Date of Birth:
                                  </label>
                                  <input
                                      type="date"
                                      id="edit-date"
                                      className="border-b border-gray-500 outline-none w-2/3 p-1 text-gray-500"
                                      value={date}
                                      max={new Date().toISOString().split("T")[0]}
                                      onChange={(e) => setDate(e.target.value)}
                                  />
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-address" className="flex items-center px-3 w-1/3">
                                      Address :
                                  </label>
                                  <input
                                      type="text"
                                      id="edit-address"
                                      className="border-b border-gray-500 outline-none w-2/3 p-1"
                                      value={address}
                                      onChange={(e) => setAddress(e.target.value)}
                                      placeholder="Address"
                                  />
                              </div>

                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-proffesion" className="flex items-center px-3 w-1/3">
                                      Profession :<span className="ml-1 text-red-500">*</span>
                                  </label>
                                  <div className="relative text-center w-2/3">
                                      <select
                                          id="edit-proffesion"
                                          className="w-full border-b border-gray-500 outline-none appearance-none p-1 bg-white"
                                          style={{ color: proffesion ? '#000' : '#BBB' }}
                                          value={proffesion}
                                          onChange={(e) => setProffesion(e.target.value)}
                                          required
                                      >
                                          <option value="" disabled>Select Profession</option>
                                          <option value="Fabric Manufacturer">Fabric Manufacturer</option>
                                          <option value="Garment Manufacturer">Garment Manufacturer</option>
                                          <option value="Yarn Manufacturer">Yarn Manufacturer</option>
                                          <option value="Trader & Broker">Trader & Broker</option>
                                          <option value="Buyer">Buyer</option>
                                          <option value="Designer">Designer</option>
                                          <option value="Finisher">Finisher</option>
                                          <option value="Other">Other</option>
                                      </select>
                                      <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                                          <MdArrowDropDown className="text-xl" />
                                      </span>
                                  </div>
                              </div>
                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-gst" className="flex items-center px-3 w-1/3">
                                      GST Number :
                                  </label>
                                  <div className="flex flex-col w-2/3">
                                      <input
                                          type="text"
                                          id="edit-gst"
                                          className={`border-b border-gray-500 outline-none p-1 ${gst && !isGstValid ? "border-red-500" : ""}`}
                                          value={gst}
                                          onChange={(e) => setGst(e.target.value)}
                                          placeholder="GST Number"
                                      />
                                      {gst && !isGstValid && (
                                          <p className="text-red-500 text-xs mt-1">Invalid GST number</p>
                                      )}
                                  </div>
                              </div>
                              <div className="flex py-3 justify-end items-center">
                                  <label htmlFor="edit-createdby" className="flex items-center px-3 w-1/3">
                                      Created By :
                                  </label>
                                  <input
                                      type="text"
                                      id="edit-createdby"
                                      className="border-b border-gray-500 outline-none w-2/3 p-1 bg-gray-100"
                                      value={createdby}
                                      disabled
                                  />
                              </div>
                          </div>
                      </div>
                      <div className="button-container flex justify-center p-1 space-x-12 pt-6">
                          <button
                              type="button"
                              onClick={handleClose}
                              className="flex-shrink-0 px-4 py-2 bg-white shadow-md rounded-md hover:bg-gray-100 transition-colors"
                              style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                          >
                              Cancel
                          </button>
                          <button
                              type="submit"
                              className="flex-shrink-0 px-4 py-2 rounded-md text-white"
                              style={{
                                  background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                              }}
                          >
                              Update
                          </button>
                      </div>
                  </form>
              </div>
          </div>
      </div>
    </>
  );
};

export default EditAffiliateForm;